/** Reads only Meta attribution cookies; blocked access or malformed values are ignored. */
export function readMetaAttribution():
  | { fbp?: string; fbc?: string }
  | undefined {
  try {
    const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
    const read = (name: string) => {
      const cookie = cookies.find((value) => value.startsWith(`${name}=`));
      if (!cookie) return undefined;
      try {
        const value = decodeURIComponent(cookie.slice(name.length + 1));
        return value && value.length <= 255 ? value : undefined;
      } catch {
        return undefined;
      }
    };
    const fbp = read("_fbp");
    const fbc = read("_fbc");
    return fbp || fbc
      ? { ...(fbp ? { fbp } : {}), ...(fbc ? { fbc } : {}) }
      : undefined;
  } catch {
    return undefined;
  }
}
